import { MtnFlagIcon, PinOutlineIcon } from "../icons"


export const TourMyCompass = () => (
  <div className='tourtip__container-content'>
    <h4>My Compass</h4>
    <p>Your personalized home page, My Compass gives you quick access to Things To Do Now, your Challenges, your Pins, and recommendations tailored just for you.</p>
  </div>
)
export const TourMyTasks = () => (
  <div className='tourtip__container-content'>
    <h4>Things to do now</h4>
    <p>Always at the top of your My Compass page, Things To Do Now is a set of 3 things you can accomplish today. These articles, videos, webinars, talks and activities have been selected just for you. Visit daily to keep the momentum going on your fitness professional journey.</p>
  </div>
)
export const TourExplore = () => (
  <div className='tourtip__container-content'>
    <h4>Explore</h4>
    <p>Search all of ACE® Pro Compass to find more on a topic you&apos;ve been studying or discover something new.</p>
  </div>
)
export const TourUserMenu = () => (
  <div className='tourtip__container-content'>
    <h4>User Menu</h4>
    <p>Click this menu button to reveal...</p>
  </div>
)
export const TourChallenges = () => (
  <div className='tourtip__container-content tourtip__container-content--challenges'>
    <h4><MtnFlagIcon width={40} height={41.43} />Challenges</h4>
    <p>Click on your profile photo to access Challenges. Challenges are collections of content and activities designed to build your knowledge and skill on a specific topic. Track your progress as you read, watch and listen.</p>
  </div>
)
export const TourPins = () => (
  <div className='tourtip__container-content tourtip__container-content--pins'>
    <h4><PinOutlineIcon width={25} height={40} />Pins</h4>
    <p>Press the pin button on anything you want to revisit and it will be saved here.</p>
  </div>
)
export const TourFinish = () => (
  <div className='tourtip__container-content'>
    <h4>Still have questions?</h4>
    <p>
      Contact us and we are happy to assist.
      Our team is available by phone at 1 (888) 825-3636 Monday-Friday 7am - 4pm PST.
      Or you can also email questions to <a href='mailto:support@acefitness.org' target='_blank' rel='noreferrer'>support@acefitness.org</a>.
    </p>
  </div>
)
